

import React, { Component } from "react";
import p5 from "p5";

import P1 from "../assets/image/p1.png"
import SpaceMono from "../assets/fonts/SpaceMono-Regular.ttf";

export default class App extends Component {
    //React ref for div reference we pass into p5
    sketchRef = React.createRef();


    //P5 instance mode
    initSketch = (p) => {
        let canvas;

        let w = window.innerWidth;
        let h = window.innerHeight;

        let rw = w * 0.65;

        let p1;

        let font;

        let basic = "It was"
        let ten = "It was ten thirty.\nand summer."

        let layer;
        p.preload = () => {
            p1 = p.loadImage(P1);
            font = p.loadFont(SpaceMono, font);
        };

        p.setup = () => {

            canvas = p.createCanvas(rw, h);
            p1.resize(50, 0);
            layer = p.createGraphics(rw, h);

        };

        p.draw = () => {
            p.background(0);


            let mag = rw * 0.4;
            // let time = p.map(p.frameCount, 0, p.frameCount, 1, 360);
            let time = p.map(p.frameCount, 0, 360, 1, 120);

            let mx = p.map(p.mouseX, 0, rw, 0, 50);
            let my = p.map(p.mouseY, 0, h, 0, 50);


            let wave = p.map(p.cos(p.radians(-p.frameCount * 0.4)), -1, 1, 0, 25);
            let wave2 = p.map(p.cos(p.radians(p.frameCount)), -1, 1, -3, 3);
            // let wave2 = p.map(-p.cos(p.frameCount * 0.05), -1, 1, -180, 180);
            let wave3 = p.map(p.tan(p.radians(-p.frameCount)), -1, 1, 0, 10);
            let wave4 = p.map(-p.cos(p.frameCount * 0.05), -1, 1, -70, 70);

            for (let i = 1; i < time; i++) {

                p.push();
                p.translate(rw / 2, h / 2);
                p.rotate(p.radians(i * 10));
                p.noStroke();
                p.fill('#7C503C');
                p.rect(mx, i + my * 10, 2, wave * 0.1);
                p.pop();


            }

            let hour = 6.5;
            let RH = p.map(hour % 12, 0, 12, 0, 360);
            let mr = p.map(p.mouseX, 0, p.width, 0, 400);

            RH += p.map(mr, 0, 360, 0, 30);

            p.push();
            p.translate(rw / 2, h / 2);
            p.rotate(p.radians(RH));
            p.stroke('#ffffff');
            p.strokeWeight(30);
            p.line(0, 0, 300, 0);
            p.pop();

            p.push();
            p.translate(rw / 2, h / 2);
            p.rotate(p.radians(90));
            p.rotate(p.radians(mr));
            p.stroke('#ffffff');
            p.strokeWeight(30);
            p.line(0, 0, 500, 0);
            p.pop();

            p.push();
            p.translate(rw / 2, h / 2);
            p.imageMode(p.CENTER);
            p.image(p1, 0, 0);
            p.pop();


            layer.textAlign(p.CENTER, p.CENTER);
            layer.background('#ffffff');
            layer.fill('#191020');


            layer.push();
            layer.translate(rw / 2, h / 2 + wave3);
            layer.ellipse(0, 0 + wave, rw / 2 + wave4, h);
            layer.pop();

            layer.push();
            layer.blendMode(p.LIGHTEST);
            layer.fill('#83A9F4');
            layer.translate(rw / 2, h / 2 + wave3);
            layer.textSize(50 + wave2);
            layer.textFont(font);
            layer.text(ten.toUpperCase(), 0, 0);
            layer.pop();


            //show the results

            if (mr > 340 && mr < 380) {
                p.translate(rw / 2, h / 2);
                p.imageMode(p.CENTER);
                p.image(layer, 0, 0);
            } else {
                // this.canvas.remove();
            }

        };

        p.windowResized = () => {
            w = window.innerWidth;
            h = window.innerHeight;
            rw = w * 0.65;
            p.resizeCanvas(rw, h);
        };

    };

    componentDidMount() {
        //Create p5 canvas once component mounts
        this.p5Canvas = new p5(this.initSketch, this.sketchRef.current);
    }

    componentWillUnmount() {
        this.p5Canvas.remove();
        window.removeEventListener('resize', this.windowResized);


    }

    render() {
        //this div will contain the sketch canvas
        return <div className="mySketch" ref={this.sketchRef} />;
    }
}


